import React from 'react';

const variantClassMap = {
  accent: 'portalr-badge--accent',
  success: 'portalr-badge--success',
  warning: 'portalr-badge--warning',
  danger: 'portalr-badge--danger',
  neutral: '',
};

/**
 * Generic semantic status badge.
 */
export const StatusBadge = ({ label, variant = 'neutral', className = '' }) => {
  return (
    <span className={`portalr-badge ${variantClassMap[variant] || ''} ${className}`.trim()}>
      {label}
    </span>
  );
};

